import {FemaGoModal, Alert} from 'app-ui-componentlibrary';
import _ from 'lodash';
import React, {useState, useContext} from 'react';
import {Header, Grid, Dropdown, Form} from 'semantic-ui-react';
import FundingOpportunityCommitmentDetails from './FundingOpportunityCommitmentDetails';
import moment from 'moment-timezone';

const FundingOpportunityCommitmentModal = ({
  isOpen,
  isEditable,
  closeModal,
  detailsData,
}) => {
  const [region, setRegion] = useState('');
  const REGIONS = ['HQ', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

  const [errorMessage, setErrorMessage] = useState('');
  const [appropriationEndDate, setAppropriationEndDate] = useState(null);
  const [popAmendmentCutoffDate, setPopAmendmentCutoffDate] = useState(null);

  return (
    <FemaGoModal
      title="Commitment Details"
      open={isOpen}
      size="small"
      buttonText="Add Commitment"
      readOnly={!isEditable}
      cancelAction={closeModal}
    >
      <FundingOpportunityCommitmentDetails
        isEditable={isEditable}
        detailsData={detailsData}
      />
    </FemaGoModal>
  );
};
export default FundingOpportunityCommitmentModal;
